var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"header"},[_c('i',{staticClass:"far fa-calendar-alt"}),_vm._v(" Body Monitor ")])}]

export { render, staticRenderFns }